<template>
  <v-expansion-panels accordion v-model="panel" multiple>

    <!-- Zone / Envelope / Material Panel -->
    <v-expansion-panel>
      <v-expansion-panel-header class="font-weight-bold"> Zone / Envelope / Material
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <!----------------- Zone Dialog Control ------------------->
        <v-dialog
          transition="dialog-bottom-transition"
          max-width="1200">

          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" v-bind="attrs" v-on="on">Edit Zone Parameters</v-btn>
          </template>

          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar color="primary" dark>Zone</v-toolbar>

              <v-col cols="12" mx-0 px-0></v-col>
              <!--Editable DataTable -->
              <v-data-table
                :headers="zone_headers"
                :items="zone_table"
                class="elevation-1"
              ><template v-slot:body="{ items, headers }">
                <tbody>
                  <tr v-for="(item,idx,k) in items" :key="idx">
                    <td v-for="(header,key) in headers" :key="key">
                      <v-edit-dialog
                        :return-value.sync="item[header.value]"
                        large
                      > {{item[header.value]}}
                        <template v-slot:input v-if="key >= 1">
                          <v-text-field 
                            v-model="item[header.value]"
                            label="Edit"
                            single-line
                            @change="item[header.value] = parseFloat(item[header.value])"
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </td>
                  </tr>
                </tbody>
                </template>  
              </v-data-table>

              <v-card-actions class="justify-end">
                <v-btn text @click="dialog.value = false">Save</v-btn>
              </v-card-actions>

            </v-card>
          </template>
        </v-dialog>

        <v-col cols="2" mx-0 px-0></v-col>
        <!--------------- Envelope Dialog Control --------------->
        <v-dialog
          transition="dialog-bottom-transition"
          max-width="1400">

          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" v-bind="attrs" v-on="on">Edit Envelope Parameters</v-btn>
          </template>

          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar color="primary" dark>Envelope</v-toolbar>

              <v-col cols="12" mx-0 px-0></v-col>
              <!--Editable DataTable -->
              <v-data-table
                :headers="envelope_headers"
                :items="envelope_table"
                class="elevation-1"
              ><template v-slot:body="{ items, headers }">
                <tbody>
                  <tr v-for="(item,idx,k) in items" :key="idx">
                    <td v-for="(header,key) in headers" :key="key">
                      <v-edit-dialog
                        :return-value.sync="item[header.value]"
                        large
                      > {{item[header.value]}}
                        <template v-slot:input v-if="key >= 1">
                          <v-text-field 
                            v-model="item[header.value]"
                            label="Edit"
                            single-line
                            @change="item[header.value] = parseFloat(item[header.value])"
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </td>
                  </tr>
                </tbody>
                </template>  
              </v-data-table>

              <v-card-actions class="justify-end">
                <v-btn text @click="dialog.value = false">Save</v-btn>
              </v-card-actions>

            </v-card>
          </template>
        </v-dialog>

        <v-col cols="2" mx-0 px-0></v-col>
        <!--------------- Material Dialog Control --------------->
        <v-dialog
          transition="dialog-bottom-transition"
          max-width="1000">

          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" v-bind="attrs" v-on="on">Edit Material Parameters</v-btn>
          </template>

          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar color="primary" dark>Material</v-toolbar>

              <v-col cols="12" mx-0 px-0></v-col>
              <!--Editable DataTable -->
              <v-data-table
                :headers="material_headers"
                :items="material_table"
                class="elevation-1"
              ><template v-slot:body="{ items, headers }">
                <tbody>
                  <tr v-for="(item,idx,k) in items" :key="idx">
                    <td v-for="(header,key) in headers" :key="key">
                      <v-edit-dialog
                        :return-value.sync="item[header.value]"
                        large
                      > {{item[header.value]}}
                        <template v-slot:input v-if="key >= 1">
                          <v-text-field 
                            v-model="item[header.value]"
                            label="Edit"
                            single-line
                            @change="item[header.value] = parseFloat(item[header.value])"
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </td>
                  </tr>
                </tbody>
                </template>  
              </v-data-table>

              <v-card-actions class="justify-end">
                <v-btn text @click="dialog.value = false">Save</v-btn>
              </v-card-actions>

            </v-card>
          </template>
        </v-dialog>

      </v-expansion-panel-content>
    </v-expansion-panel>

    <!--------------- Schedules / Operation / Occupancy Panel --------------->
    <v-expansion-panel>
      <v-expansion-panel-header class="font-weight-bold"> Schedules / Operation / Occupancy
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <!-- Schedule Dialog Control -->
        <v-dialog
          transition="dialog-bottom-transition"
          max-width="800">

          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" v-bind="attrs" v-on="on">Edit Schedule Parameters</v-btn>
          </template>

          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar color="primary" dark>Schedule</v-toolbar>

              <v-col cols="12" mx-0 px-0></v-col>
              <!--Editable DataTable -->
              <v-data-table
                :headers="schedule_headers"
                :items="schedule_table"
                class="elevation-1"
                dense
              ><template v-slot:body="{ items, headers }">
                <tbody>
                  <tr v-for="(item,idx,k) in items" :key="idx">
                    <td v-for="(header,key) in headers" :key="key">
                      <v-edit-dialog
                        :return-value.sync="item[header.value]"
                        large
                      > {{item[header.value]}}
                        <template v-slot:input v-if="key >= 1">
                          <v-text-field 
                            v-model="item[header.value]"
                            label="Edit"
                            single-line
                            @change="item[header.value] = parseFloat(item[header.value])"
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </td>
                  </tr>
                </tbody>
                </template>  
              </v-data-table>

              <v-card-actions class="justify-end">
                <v-btn text @click="dialog.value = false">Save</v-btn>
              </v-card-actions>

            </v-card>
          </template>
        </v-dialog>

        <v-col cols="2" mx-0 px-0></v-col>
        <!--------------- Operation Dialog Control --------------->
        <v-dialog
          transition="dialog-bottom-transition"
          max-width="1000">

          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" v-bind="attrs" v-on="on">Edit Operation Parameters</v-btn>
          </template>

          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar color="primary" dark>Operation</v-toolbar>


              <v-card-actions class="justify-end">
                <v-btn text @click="dialog.value = false">Save</v-btn>
              </v-card-actions>

            </v-card>
          </template>
        </v-dialog>

        <v-col cols="2" mx-0 px-0></v-col>
        <!--------------- Occupancy Dialog Control -------------->
        <v-dialog
          transition="dialog-bottom-transition"
          max-width="1000">

          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" v-bind="attrs" v-on="on">Edit Occupancy Parameters</v-btn>
          </template>

          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar color="primary" dark>Occupancy</v-toolbar>


              <v-card-actions class="justify-end">
                <v-btn text @click="dialog.value = false">Save</v-btn>
              </v-card-actions>

            </v-card>
          </template>
        </v-dialog>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <!--------------- Calibration Panel --------------->
    <v-expansion-panel>
      <v-expansion-panel-header class="font-weight-bold"> Calibration
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <!-- Calibration Dialog Control -->
        <v-dialog
          transition="dialog-bottom-transition"
          max-width="800">

          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" v-bind="attrs" v-on="on">Edit Calibration Parameters</v-btn>
          </template>

          <template v-slot:default="dialog">
            <v-card>
              <v-toolbar color="primary" dark>Calibration</v-toolbar>

              <v-col cols="12" mx-0 px-0></v-col>
              <!--Editable DataTable -->
              <v-data-table
                :headers="calibration_headers"
                :items="calibration_table"
                class="elevation-1"
                dense
              ><template v-slot:body="{ items, headers }">
                <tbody>
                  <tr v-for="(item,idx,k) in items" :key="idx">
                    <td v-for="(header,key) in headers" :key="key">
                      <v-edit-dialog
                        :return-value.sync="item[header.value]"
                        large
                      > {{item[header.value]}}
                        <template v-slot:input v-if="key >= 1">
                          <v-text-field 
                            v-model="item[header.value]"
                            label="Edit"
                            single-line
                            @change="item[header.value] = parseFloat(item[header.value])"
                          ></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </td>
                  </tr>
                </tbody>
                </template>  
              </v-data-table>

              <v-card-actions class="justify-end">
                <v-btn text @click="dialog.value = false">Save</v-btn>
              </v-card-actions>

            </v-card>
          </template>
        </v-dialog>
      </v-expansion-panel-content>
    </v-expansion-panel>

  </v-expansion-panels>
</template>

<script>
export default {
  data: () => ({
    panel: [],
//-------------------Zone Table Items ------------------------- //
    zone_headers: [
      { text: 'Zone',
        align: 'start',
        sortable: false,
        value: 'name',
      },
      { text: 'Zone 1: Basement', value: 'z1' },
      { text: 'Zone 2: Creative Commons', value: 'z2' },
      { text: 'Zone 3: Catering Support', value: 'z3' },
      { text: 'Zone 4: Auditorium', value: 'z4' },
      { text: 'Zone 5: Maker Space', value: 'z5' },
      { text: 'Zone 6: Classroom/Labs', value: 'z6' },
      { text: 'Zone 7: Elect./Telecom', value: 'z7' },
      { text: 'Zone 8: Office', value: 'z8' },
      { text: 'Zone 9: Circulation', value: 'z9' },
      { text: 'Zone 10: Restrooms', value: 'z10' },
    ],
    zone_table: [{
        name: 'Gross Floor Area (m2)',
        z1: 456,  z2: 333,  z3: 12,  z4: 377,  z5: 111, 
        z6: 783,  z7: 102,  z8: 233,  z9: 679, z10: 125 
      },{
        name: 'Occupancy (person)',
        z1: 5,  z2: 30,  z3: 2,  z4: 160,  z5: 40, 
        z6: 350,  z7: 25,  z8: 20,  z9: 60, z10: 2 
      },{
        name: 'Metabolic rate (W/person)',
        z1: 150,  z2: 150,  z3: 150,  z4: 150,  z5: 150, 
        z6: 150,  z7: 150,  z8: 150,  z9: 150, z10: 150 
      },{
        name: 'Appliance (W/m2)',
        z1: 3.75,  z2: 15,  z3: 70.2,  z4: 5.63,  z5: 45.23, 
        z6: 5.12,  z7: 9.41,  z8: 23.4,  z9: 0, z10: 1.5 
      },{
        name: 'Lighting (W/m2)',
        z1: 3.83,  z2: 3.83,  z3: 3.83,  z4: 3.83,  z5: 3.83, 
        z6: 3.83,  z7: 3.83,  z8: 3.83,  z9: 3.83, z10: 3.83 
      },{
        name: 'Outdoor Air (liter/s/person)',
        z1: 8.33,  z2: 8.33,  z3: 8.33,  z4: 8.33,  z5: 8.33, 
        z6: 8.33,  z7: 8.33,  z8: 8.33,  z9: 8.33, z10: 8.33 
      },{
        name: 'DHW (liter/m2/month)',
        z1: 4,  z2: 0,  z3: 8,  z4: 0,  z5: 4, 
        z6: 0,  z7: 0,  z8: 4,  z9: 0, z10: 8 
      },
    ],
//-------------------EnvelopeTable Items ------------------------- //
    envelope_headers: [
      { text: 'Orientation',
        align: 'start',
        sortable: false,
        value: 'name',
      },
      { text: 'Opaque1_Area [m2]', value: 'e1' },
      { text: 'Opaque2_Area [m2]', value: 'e2' },
      { text: 'Window1_Area [m2]', value: 'e3' },
      { text: 'Window1 Overhang Angle [degree]', value: 'e4' },
      { text: 'Window1 Fin Angle [degree]', value: 'e5' },
      { text: 'Window1 Horizon Angle [degree]', value: 'e6' },
      { text: 'SRF1', value: 'e7' },
      { text: 'Window2_Area [m2]', value: 'e8' },
      { text: 'Window2 Overhang Angle [degree]', value: 'e9' },
      { text: 'Window2 Fin Angle [degree]', value: 'e10' },
      { text: 'Window2 Horizon Angle [degree]', value: 'e11' },
      { text: 'SRF2', value: 'e12' },
    ],
    envelope_table: [{
        name: 'S',
        e1: 121.5,  e2: 120.48,  e3: 159.27,  e4: 45,  e5: 0,  e6: 0,
        e7: 0.8,  e8: 0,  e9: 0, e10: 0, e11: 0, e12: 1
      },{
        name: 'SE',
        e1: 0,  e2: 0,  e3: 0,  e4: 0,  e5: 0,  e6: 0,
        e7: 0,  e8: 0,  e9: 0, e10: 0, e11: 0, e12: 1
      },{
        name: 'E',
        e1: 450.6,  e2: 193.19,  e3: 155.35,  e4: 0,  e5: 0,  e6: 0,
        e7: 0.8,  e8: 0,  e9: 0, e10: 0, e11: 0, e12: 1
      },{
        name: 'NE',
        e1: 0,  e2: 0,  e3: 0,  e4: 0,  e5: 0,  e6: 0,
        e7: 0,  e8: 0,  e9: 0, e10: 0, e11: 0, e12: 1
      },{
        name: 'N',
        e1: 264.4,  e2: 97.56,  e3: 136.52,  e4: 0,  e5: 0,  e6: 0,
        e7: 0.8,  e8: 0,  e9: 0, e10: 0, e11: 0, e12: 1
      },{
        name: 'NW',
        e1: 0,  e2: 0,  e3: 0,  e4: 0,  e5: 0,  e6: 0,
        e7: 0,  e8: 0,  e9: 0, e10: 0, e11: 0, e12: 1
      },{
        name: 'W',
        e1: 230.8,  e2: 157.5,  e3: 175.86,  e4: 45,  e5: 0,  e6: 0,
        e7: 0.8,  e8: 0,  e9: 0, e10: 0, e11: 0, e12: 1
      },{
        name: 'SW',
        e1: 0,  e2: 0,  e3: 0,  e4: 0,  e5: 0,  e6: 0,
        e7: 0,  e8: 0,  e9: 0, e10: 0, e11: 0, e12: 1
      },{
        name: 'Roof(Hor)',
        e1: 928,  e2: 509.36,  e3: 0,  e4: 0,  e5: 0,  e6: 0,
        e7: 0.1,  e8: 0,  e9: 0, e10: 0, e11: 0, e12: 1
      },{
        name: 'Below Grade',
        e1: 0,  e2: 0,  e3: 0,  e4: 0,  e5: 0,  e6: 0,
        e7: 0,  e8: 0,  e9: 0, e10: 0, e11: 0, e12: 0
      },
    ],
//-------------------Material Table Items ------------------------- //
    material_headers: [
      { text: 'Type',
        align: 'start',
        sortable: false,
        value: 'name',
      },
      { text: 'Uvalue [W/m2/K]', value: 'm1' },
      { text: 'Absorption coefficient', value: 'm2' },
      { text: 'Emissivity', value: 'm3' },
      { text: 'Solar Transmittance', value: 'm4' },
    ],
    material_table: [{
        name: 'Roof 1',
        m1: 0.25,  m2: 0.85,  m3: 0.6,  m4: 0,
      },{
        name: 'Roof 2',
        m1: 0.35,  m2: 0.9,  m3: 0.8,  m4: 0,
      },{
        name: 'Opaque 1',
        m1: 0.7,  m2: 0.7,  m3: 0.7,  m4: 0,
      },{
        name: 'Opaque 2',
        m1: 0.7,  m2: 0.7,  m3: 0.7,  m4: 0,
      },{
        name: 'Window 1',
        m1: 2.19,  m2: 0,  m3: 0.3,  m4: 0.22,
      },{
        name: 'Window 2',
        m1: 0,  m2: 0,  m3: 0,  m4: 0,
 
      },
    ],
//-------------------Schedule Table Items ------------------------- //
    schedule_headers: [
      { text: 'Hour',
        align: 'start',
        sortable: false,
        value: 'name',
      },
      { text: 'WD_Tset_heat', value: 's1' },
      { text: 'WE_Tset_heat', value: 's2' },
      { text: 'WD_Tset_cool', value: 's3' },
      { text: 'WE_Tset_cool', value: 's4' },
    ],
    schedule_table: [
        { name: '01', s1: 15,   s2: 16,  s3: 27.22,  s4:29,
      },{ name: '02', s1: 15,   s2: 16,  s3: 27.22,  s4:29,
      },{ name: '03', s1: 15,   s2: 16,  s3: 27.22,  s4:29,
      },{ name: '04', s1: 15,   s2: 16,  s3: 27.22,  s4:29,
      },{ name: '05', s1: 21.1, s2: 16,  s3: 27.22,  s4:29,
      },{ name: '06', s1: 21.1, s2: 16,  s3: 27.22,  s4:29,
      },{ name: '07', s1: 21.1, s2: 16,  s3: 27.22,  s4:29,
      },{ name: '08', s1: 21.1, s2: 16,  s3: 25.9,   s4:29,
      },{ name: '09', s1: 21.1, s2: 16,  s3: 25.9,   s4:29,
      },{ name: '10', s1: 21.1, s2: 16,  s3: 25.9,   s4:29,
      },{ name: '11', s1: 21.1, s2: 16,  s3: 25.9,   s4:29,
      },{ name: '12', s1: 21.1, s2: 16,  s3: 25.9,   s4:29,
      },{ name: '13', s1: 21.1, s2: 16,  s3: 25.9,   s4:29,
      },{ name: '14', s1: 21.1, s2: 16,  s3: 25.9,   s4:29,
      },{ name: '15', s1: 21.1, s2: 16,  s3: 25.9,   s4:29,
      },{ name: '16', s1: 21.1, s2: 16,  s3: 25.9,   s4:29,
      },{ name: '17', s1: 21.1, s2: 16,  s3: 25.9,   s4:29,
      },{ name: '18', s1: 21.1, s2: 16,  s3: 25.9,   s4:29,
      },{ name: '19', s1: 21.1, s2: 16,  s3: 25.9,   s4:29,
      },{ name: '20', s1: 15,   s2: 16,  s3: 25.9,   s4:29,
      },{ name: '21', s1: 15,   s2: 16,  s3: 27.22,  s4:29,
      },{ name: '22', s1: 15,   s2: 16,  s3: 27.22,  s4:29,
      },{ name: '23', s1: 15,   s2: 16,  s3: 27.22,  s4:29,
      },{ name: '00', s1: 15,   s2: 16,  s3: 27.22,  s4:29,
      },
    ],
//-------------------Calibration Table Items ------------------------- //
    calibration_headers: [
      { text: 'Type',
        align: 'start',
        sortable: false,
        value: 'name',
      },
      { text: 'Cool', value: 'c1' },
      { text: 'Heat', value: 'c2' },
    ],
    calibration_table: [
        { name: 'RAD_RES', c1: 0.0005, c2:	0.0005,
      },{ name: 'CHW_AIR', c1: 2.457128, c2:	1.996808,
      },{ name: 'CHW_RAD', c1: 0.338819, c2:	0.310494,
      },{ name: 'HVAC_AIR', c1: 0.401138, c2:	3.252208,
      },{ name: 'HVAC_RAD', c1: 0.146219, c2:	0.494789,
      },{ name: 'HVAC_OFFSET', c1: 3.477232, c2: null,
      },{ name: 'CHW_OFFSET', c1: 2.926261, c2:	0,
      },{ name: 'AIRFLOW', c1: 1, c2:	null,
      }
    ],




//-------------------End of Table Items ------------------------- //
  }),
  methods: {
    updateVar() {
      this.$store.commit("updateDTW_advParam",[
        this.zone_table, this.envelope_table, this.material_table, this.schedule_table, this.calibration_table,
      ])
    },
  },
  watch: {
    '$store.state.DTW.run': function() {
      if (this.$store.state.DTW.run === "updateVar2") {
        this.updateVar()
        this.$store.commit("updateDTW_run",'running')

      } else if (this.$store.state.DTW.run === "updateVar2_download"){
        this.updateVar()
        let bdata = {
          "start":this.$store.state.DTW.start, 
          "end":this.$store.state.DTW.end,
          
          "general":this.$store.state.DTW.general,
          "lighting":this.$store.state.DTW.lighting,
          "cop":this.$store.state.DTW.COP,
          "HVACsys":this.$store.state.DTW.HVACsys,
          "DHWsys":this.$store.state.DTW.DHWsys,
          "PVsys":this.$store.state.DTW.PVsys,

          "zone":this.$store.state.DTW.zone,
          "envelope":this.$store.state.DTW.envelope,
          "material":this.$store.state.DTW.material,

          "schedule":this.$store.state.DTW.schedule,
          "calibration":this.$store.state.DTW.calibration,
          "calibration_table":this.$store.state.DTW.calibration_table
        } 
        let data = JSON.stringify(bdata, null, 2)
        let filename = 'input.json';
        let element = document.createElement('a');
        element.setAttribute('href', 'data:application/json;charset=utf-8,' + encodeURIComponent(data));
        element.setAttribute('download', filename);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();
        document.body.removeChild(element);  
        this.$store.commit("updateDTW_run",'idle')

      } else if (this.$store.state.DTW.run === "updateVar2_upload") {
        this.zone_table = this.$store.state.DTW.zone,
        this.envelope_table = this.$store.state.DTW.envelope
        this.material_table = this.$store.state.DTW.material
        this.schedule_table = this.$store.state.DTW.schedule
        this.calibration_table = this.$store.state.DTW.calibration_table
        this.$store.commit("updateDTW_run",'idle')
      }
    }
  },
  computed: {

  },
}
</script>
